import { RemoteCateringMenu } from "../../../../../../ServiceManagement/Catering/Domain/Types/Remote-CateringMenu.types";
import { AssignedBookableEquipment } from "../../../../../Domain/Types/FloorPlan/BookableEquipmentAssignment.type";
import { AssignedCateringMenu } from "../../../../../Domain/Types/FloorPlan/CateringMenuAssignment.type";
import { IEquipmentInventory } from "../../../../../Domain/Types/FloorPlan/Equipment.type";
import { IFloorPayload } from "../../../../../Domain/Types/FloorPlan/FloorPayload.type";
import {
  AssignedRoomlayout,
  RemoteRoomlayout
} from "../../../../../Domain/Types/FloorPlan/RoomlayoutAssignment.type";
import { IZoneSchedule } from "../../../../../Domain/Types/FloorPlan/ZoneSchedule";

export const initialBookableEquipmentAssign = ({
  floorPlan,
  zoneSchedules,
  remoteBookableEquipment,
  setBookableEquipment,
  setAssignedBookableEquipment
}: {
  floorPlan: IFloorPayload;
  zoneSchedules: IZoneSchedule[];
  remoteBookableEquipment: IEquipmentInventory[] | undefined;
  setBookableEquipment: (remote: IEquipmentInventory[]) => void;
  setAssignedBookableEquipment: (equ: AssignedBookableEquipment[]) => void;
}) => {
  if (!remoteBookableEquipment) return;

  // find the assigned to the selected zone
  const bookableEquipAssigned = floorPlan.bookableEquipmentAssignments?.find(ba =>
    zoneSchedules.some(zn => zn.id === ba.zoneScheduleId)
  )?.bookableEquipmentIds;

  const initial = remoteBookableEquipment
    ?.map(eq => {
      const bookEq = bookableEquipAssigned?.find(item => item.bookableEquipmentId === eq.id);
      if (bookEq) return { ...bookEq, ...eq };
      return null;
    })
    .filter(item => item !== null) as AssignedBookableEquipment[];

  if (initial?.length) setAssignedBookableEquipment(initial);
  else setAssignedBookableEquipment([]);

  setBookableEquipment(remoteBookableEquipment);
};

export const initialCateringItemsAssign = ({
  floorPlan,
  zoneSchedules,
  remoteAllCateringServices,
  setAllCateringServices,
  setAssignedCateringItems
}: {
  floorPlan: IFloorPayload;
  zoneSchedules: IZoneSchedule[];
  remoteAllCateringServices: RemoteCateringMenu[] | undefined;
  setAllCateringServices: (remote: RemoteCateringMenu[]) => void;
  setAssignedCateringItems: (items: AssignedCateringMenu[]) => void;
}) => {
  if (!remoteAllCateringServices) return;

  // find the assigned to the selected zone
  const cateringItemsAssigned = floorPlan.cateringMenuAssignments?.find(ba =>
    zoneSchedules.some(zn => zn.id === ba.zoneScheduleId)
  )?.cateringMenuIds;

  const initial = remoteAllCateringServices
    ?.map(cat => {
      const items = cateringItemsAssigned?.find(item => item.cateringMenuId === cat.id);
      if (items) return { ...items, ...cat };
      return null;
    })
    .filter(item => item !== null) as AssignedCateringMenu[];

  if (initial?.length) setAssignedCateringItems(initial);
  else setAssignedCateringItems([]);

  setAllCateringServices(remoteAllCateringServices);
};

export const initialRoomLayoutAssign = ({
  floorPlan,
  zoneSchedules,
  remoteRoomLayout,
  setRoomLayout,
  setAssignedRoomLayout
}: {
  floorPlan: IFloorPayload;
  zoneSchedules: IZoneSchedule[];
  remoteRoomLayout: RemoteRoomlayout[] | undefined;
  setRoomLayout: (remote: RemoteRoomlayout[]) => void;
  setAssignedRoomLayout: (layout: AssignedRoomlayout[]) => void;
}) => {
  if (!remoteRoomLayout) return;

  // find the assigned to the selected zone
  const roomLayoutAssigned = floorPlan.roomLayoutAssignments?.find(ba =>
    zoneSchedules.some(zn => zn.id === ba.zoneScheduleId)
  )?.roomLayoutIds;

  const initial = remoteRoomLayout
    ?.map(cat => {
      const items = roomLayoutAssigned?.find(item => item.roomLayoutId === cat.id);
      if (items) return { ...items, ...cat };

      return null;
    })
    .filter(item => item !== null) as AssignedRoomlayout[];

  if (initial?.length) setAssignedRoomLayout(initial);
  else setAssignedRoomLayout([]);

  setRoomLayout(
    remoteRoomLayout.map(layout => ({
      ...layout,
      arrangement: layout.arrangement
    }))
  );
};
